export default "__VITE_ASSET__Xm7IFWs1__"